import React, { Fragment, useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { Hero, HomeContent, HeroNew, TitleHero } from "../components";

const Home = () => {
  
  useEffect(() => {
    mixpanel.track('Home Page', {'action' : 'pageview'})
}, [,])
  
  return (
  <Fragment>
    <TitleHero/>
  </Fragment>
);}

export default Home;
